<div class="accordion-container" [ngClass]="[step.isListItemOpened ? 'open' :'']"
  *ngFor="let step of subSectionSteps; let i = index">
  <!-- <div > -->
  <form #stepsForm="ngForm" autocomplete="off" novalidate>
    <ion-item  class="ion-item-css" lines="none" (click)="toggleAccordion(step,i,subSectionSteps)">
      <ion-label>{{step.stepBody || 'Add a Question' | translate}}</ion-label>
      <ion-icon name="chevron-down-outline"></ion-icon>
    </ion-item>
    <div class="content">
      <div class="question-container">
        <ion-label> {{ 'Question' | translate}}</ion-label>
        <ion-item lines=none>
          <ion-textarea rows="6" cols="20" [readonly]="readonly" [(ngModel)]="step.stepBody" name="stepBody" required #stepBody="ngModel"></ion-textarea>
        </ion-item>
      </div>

      <!-- <div class="question-container">
        <ion-label> {{ 'Notes' | translate}}</ion-label>
        <ion-item lines=none>
          <ion-textarea [(ngModel)]="step.stepNote" readonly="true"  [(ngModel)]="step.stepNote" name="stepNote" #stepNote="ngModel">
          </ion-textarea>
        </ion-item>
      </div>
      <ion-list class="radio-list" >
        <ion-radio-group [(ngModel)]="step.compliance" name="compliance" #compliance="ngModel">
          <ion-row>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Yes, Compliant' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="true" value="yesCompliant"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-radio-group>
      </ion-list>
      <div *ngIf="step.compliance==='yesCompliant' && step.isListItemOpened">
        <ion-row>
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" style="padding-left: 20px;" *ngIf="step?.hasOwnProperty('answers')">
                <ion-row>
                  <ion-col size="4" *ngFor="let each of step?.answers[0]?.complaintMedia;let i=index">
                    <div *ngIf="each.imgUrl" style="position:relative; width:'mainimagewidth'">
                      <img [src]="each.imgUrl" style="height: 8rem;width:90%;margin-right: -22px;" alt="" />
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="step.hazardCount!=0 && step?.answers && step?.answers[0]?.hazardDetails">
        <div class="table_wrapper">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th class="text th" style="position: sticky; left: 0; z-index: 3;background: #f0f4fb;"> {{ 'Hazard Name'|translate}}
                </th>
              </thead>
              <tr *ngFor="let eachHazard of step?.answers[0].hazardDetails">
                <td class="td"
                  style="position: sticky; left: 0; z-index: 2; background: #f0f4fb;font-weight: bold;color: #083A81; font-weight: bold;cursor: pointer"
                  (click)="editHazard(eachHazard,step)">
                  <span>{{eachHazard?.name}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div> -->

    </div>
  </form>
</div>